export default __webpack_public_path__ + "static/media/Integrity.a531335f.png";